<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int, validate_not_empty} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(', ');

            widthGluh = +title[1].split('x')[0];
            heightGluh = +title[1].split('x')[1];

            ind2 = title[4].split(' ')[1].replace('Ral', ''); // "  7016  "


            for (var element of color_type) {
                if (title[4].includes(element)) {
                    ind10 = element;
                }
            }
            for (var element of kolvostkol) {
                if (title[3].includes(element)) {
                    ind12 = element;
                }
            }
            for (var key in ost_type) {
                if (title[2].includes(key)) {
                    ind3 = key;
                }
            }

            for (var key in glass) {
                if (title[3].includes(key)) {
                    ind4 = key;
                }
            }

            if (item.title.includes('алюм. труба')) {
                ind11 = title[5].replace('алюм. труба ', '');
            } else {
                ind11 = '';
            }


            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch();
            change();
        }
    };


    const ost_type = {
        'прямоугольник': 'прямоугольник',
        'треугольник-равнобедренный': 'треугольник равнобедренный',
        'треугольник-прямоугольный': 'треугольник прямоугольный',
    };
    const kolvostkol = [
        '1',
        '2',
        '3',
    ];

    const color_type = [
        'Глянцевый',
        'Матовый',
        'Муар',
    ];
    const glass = {
        'Прозрачное (M1) 10мм зак.': 'Прозрачное (M1) 10мм зак.',
        'Бронза (AGC) 10мм зак.': 'Бронза (AGC) 10мм зак.',
        'Грей (AGC) 10мм зак.': 'Грей (AGC) 10мм зак.',
        'Матовое 10мм зак.': 'Матовое 10мм зак.',
        'Мультифункциональное (Neutral 67) 10мм зак.': 'Мультифункциональное (Neutral 67) 10мм зак.',
        'Просветленное (AGC) 10мм зак.': 'Просветленное (AGC) 10мм зак.',
    };


    const fetch = async (color = '') => {
        let result = await network.fetch_data('Cлайдорс глух.', '', '');
        let options = await network.fetch_ind('Cлайдорс глух.');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let

        heightGluh = '',
        widthGluh = '',
        ind2 = '', // цвет RAL
        ind3 = 'прямоугольник', // тип
        ind4 = 'Прозрачное (M1) 10мм зак.', // стекло

        ind10 = 'Глянцевый', // тип цвета
        ind11 = '', // длинна  Труба алюминиевая
        ind12 = '1', // длинна  Труба алюминиевая
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1),

        stvwid = ''
    ;

    let fetchData = fetch();


    let title;


    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count;


        if (ind11 > 0) {
            title = [
                'Глухое остекление, ', widthGluh + 'x' + heightGluh, ', тип ',
                ind3, ', стекло ', ind4, ' ', ind12, ' шт., цвет Ral', ind2, ' ', ind10, ', алюм. труба ', ind11
            ].join('')

        } else {
            title = [
                'Глухое остекление, ', widthGluh + 'x' + heightGluh, ', тип ',
                ind3, ', стекло ', ind4, ' ', ind12, ' шт., цвет Ral', ind2, ' ', ind10
            ].join('')


        }


        let result = {
            type: 'Глухое остекление',
            name: 'Глухое остекление',
            subname: title.replace('Глухое остекление, ', ''),
            title: title,
            params: {
                ind1: ind3.toLowerCase() + '-' + ind12,
                ind2: 'Ral' + ind2 + ' ' + ind10,
                ind3: 'тип ' + ind3 + ', стекло ' + ind4 + ' ' + ind12 + ' шт.',
                ind4: widthGluh,
                ind5: heightGluh,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 60
        };

     //   ind3:  title.replace('Слайдорс 4, ' + w + 'x' + h + ', ',  '').replace(', цвет Ral' + ind2 + ' '+ind10, '') + osteklGluh,

            stvwid = '';


        _.forEach(data.result, function (el) {
            let item = _.cloneDeep(el);
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            let typeOtkr = ind3;


            if (name.includes('стекло')) {
                if (name.includes(ind4.toLowerCase())) {
                    if (typeOtkr.includes('прямоугольник') &&  item.ind3==='') {

                        kolvo = ((+widthGluh ) * (+heightGluh ) / 1000000 ).toFixed(3);

                    }

                    if (typeOtkr.includes('треугольник') &&  item.ind3==='Треугольник') {

                        kolvo = ((+widthGluh ) * (+heightGluh ) / 1000000 ).toFixed(3);

                    }
                }
            }

            if (name.includes('труба алюминий 100х100 длинна 3м') && +ind11 > 0 && +ind11 <= 3000) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('труба алюминий 100х100 длинна 6м') && +ind11 > 3000) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('зажимной профиль') && +widthGluh > 0 && +heightGluh > 0) {

                if (typeOtkr.includes('прямоугольный')) {
                    kolvo = (((+widthGluh) + (+heightGluh) + Math.sqrt(widthGluh * widthGluh + heightGluh * heightGluh)) / 1000).toFixed(3);
                } else if (typeOtkr.includes('равнобедренный')) {
                    kolvo = ((2 * Math.sqrt(heightGluh * heightGluh + (widthGluh / 2) * (widthGluh / 2)) + widthGluh) / 1000).toFixed(3);

                } else {
                    kolvo = ((widthGluh * 2 + heightGluh * 2) / 1000).toFixed(3);
                }
            }


            // работа с ценами
            if (ind10 == 'Муар') { // +3% к цене за квадрат при выборе Муар
                item.price = item.price / 100 * 103;
                item.opt_price = item.opt_price / 100 * 103;
            }

            if (item.ind1 === '1') {  //убираем из расчет материалы, которые входят в стоимость м.кв.
                item.price = item.opt_price = 0;
            }


            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);

    change();
</script>

    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            <div class="col-12 col-sm-5">

                <div class="form-group boxed mb-3">
                    <div class="input-wrapper">
                        <label class="form-label">Количество изделий</label>
                        <input type="number" class="form-control" min="1" bind:value={$count}
                               use:validate_int={count}>
                    </div>
                </div>

                <div class="text-center">
                    <img style="max-height: 250px" class="img-fluid px-3" alt="{ind3.toLowerCase()}-{ind12}"
                         src="/img/slaydors/открывание-{ind3.toLowerCase()}-{ind12}.jpg"/>

                </div>

                {#if widthGluh * heightGluh > 0 }
                    <div class="row pt-3">
                        <div class="col-12 text-center">
                            <span class="form-label text-center">
                                { stvwid.split(' мм.').join(" мм. ") }
                            </span>
                        </div>
                        <div class="col-12 text-center">
                            {#if (ind3.includes('треугольник')) }
                                <span class="form-label text-center">Площадь остекления: {((+widthGluh) * (+heightGluh) / 2 / 1000000).toFixed(2) }м.кв.</span>
                            {:else}
                                <span class="form-label text-center">Площадь остекления: {((+widthGluh) * (+heightGluh) / 1000000).toFixed(2)}м.кв.</span>
                            {/if}
                        </div>
                    </div>
                {/if}
            </div>

            <div class="col-12 col-sm-7">
                <div class="row">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Ширина, мм</label>
                                    <input type="number" class="form-control" step="10" min="250"
                                           bind:value={widthGluh}>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Высота, мм</label>
                                    <input type="number" class="form-control" step="10" min="250"
                                           bind:value={heightGluh}>
                                </div>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">

                                    <label class="form-label">Тип остекления</label>

                                    <select class="form-control form-select" bind:value={ind3}>
                                        {#each Object.entries(ost_type) as [value, name]  }
                                            <option value="{value}">{name}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Количество стекол</label>
                                    <select class="form-control form-select" bind:value={ind12}>
                                        {#each (kolvostkol) as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>

                                </div>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Цвет Ral</label>
                                    <input type="number" class="form-control" use:validate_not_empty={ind2}
                                           bind:value={ind2}>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Тип окрашивания</label>
                                    <select class="form-control form-select" bind:value={ind10}>
                                        {#each color_type as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Стекло</label>
                                    <select class="form-control form-select" bind:value={ind4}>
                                        {#each Object.entries(glass) as [value, name]}
                                            <option value="{value}">{name}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Труба алюминиевая 100х100, мм</label>
                                    <input type="number" class="form-control" bind:value={ind11}>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <div class="input-wrapper">
                                        <label class="form-label">Примечание</label>
                                        <textarea class="form-control" bind:value={$comment}></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
